import { useState } from "react"
import { useParams } from "react-router-dom";
import { useEffect } from "react";

export default function ProductDetail({cartItem, setcartItem}){
    const [product, setProduct] = useState(null);
    const [qty, setQty] = useState(1);
    const {sku} = useParams();
    useEffect(()=>{
          fetch(process.env.REACT_APP_API_URL+'action=read&table=products&sku='+sku)
          .then(res => res.json())
          .then(res => setProduct(res.data[0]))
        },[])

    function addToCart(){
        const itemExist = cartItem.find((item) => item.product.sku == product.sku)
        if(!itemExist){
            const newItem = {product,qty};
            setcartItem((state) => [...state,newItem]);
            alert('cart Item added successfully!');
        }
    }    

    function increaseQty(){
        if(product.quantity == qty){
            return;
        }
        setQty((state) => state+1);
    }

    function decreaseQty(){
        if(qty>1){
            return setQty((state) => state-1);
        }
    }

    return  product && <div className="container container-fluid">
                <div className="row f-flex justify-content-around">
                    <div className="col-12 col-lg-5 img-fluid" id="product_image">
                        <img src={product.image} alt="sdf" height="300" width="300" />
                    </div>
                    <div className="col-12 col-lg-5 mt-5">
                        <h3>{product.name}</h3>
                        <p id="product_id">Product # {product.sku}</p>
                        <hr />
                        <div className="rating-outer">
                            <div className="rating-inner" style={{width:`${product.rate/5 *100}%`}}></div>
                        </div>
                        <hr />
                        <p id="product_price">${product.price}</p>
                        <div className="stockCounter d-inline">
                            <span className="btn btn-danger minus" onClick={decreaseQty}>-</span>
                            <input type="number" className="form-control count d-inline" value={qty} readOnly />
                            <span className="btn btn-primary plus" onClick={increaseQty}>+</span>
                        </div>
                        <button type="button" onClick={addToCart} id="cart_btn" className="btn btn-primary d-inline ml-4" disabled = {product.quantity==0}>Add to Cart</button>
                        <hr />
                        <p>Status: <span id="stock_status" className={product.quantity>0?'text-success':'text-danger'}>{product.quantity>0?'In Stock':'Out of stock'}</span></p>
                        <hr />
                        <h4 className="mt-2">Description:</h4>
                        <p>{product.description}</p>
                        <hr />
                        <p id="product_seller mb-3">Sold by: <strong>{product.seller}</strong></p>
                        <div className="rating w-50"></div>    
                    </div>
                </div>
        </div>
}